import React, { useState, useEffect, useCallback } from "react";
import Table from "../../common/Table/table";
import AddUpdateClinicRadiologyMaster from "./addUpdateClinicRadiologyMaster";
import { useDispatch, useSelector } from "react-redux";
import { getAllClinic } from "../../../store/slices/clinicSlice";
import {
  getClinicRadiologyServicesDetailsMaster,
  resetgetRadiologyServicesDetails,
  updateClinicRadiologyServicesDetailsMaster,
  retsetUpdateRadiologyMaterMessage,
  resetDeleteRadiologyMaterMessage,
  deleteRadiologyServiceDetails,
} from "../../../store/slices/clinicRadiologyServiceDetails";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const ClinicRadiologyServicesMaster = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const initialState = {
    id: "",
    serviceId: "",
    serviceName: "",
    serviceDetailsId: [],
    serviceDetailsName: "",
    name: "",
    weight: "",
    pt_price: "",
    client_Price: "",
    tax: "",
    status: "Active",
  };
  const [inputError, setInputError] = useState({
    onlyNumber: false,
  });
  const [radiologyMasterFormData, setRadiologyMasterFormData] =
    useState(initialState);
  const dispatch = useDispatch();
  const {
    searchMessage,
    radiologyServicesDetails,
    updateRadiologyMaterSuccessMessage,
    updateRadiologyMaterErrorMessage,
    deleteRadiologyMaterSuccessMessage,
    deleteRadiologyMaterErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.clinicRadiologyServiceDetails);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  const clinicId = clinicInfo?.[0]?.clinicId ;
  const fetchRadiology = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getClinicRadiologyServicesDetailsMaster({
            clinicId,
            searchQuery: search || undefined,
            token,
            status: tableStatus,
            currentPage: page,
            limit: lim,
          }),
        );
      }
    },
    [clinicId, token, dispatch, tableStatus, searchValue, pageLimit],
  );
  useEffect(() => {
    dispatch(getAllClinic({ token }));
    dispatch(resetgetRadiologyServicesDetails());
    fetchRadiology(1, pageLimit, searchValue);
  }, [
    dispatch,
    modalVisible,
    deleteModal,
    showStatus,
    token,
    clinicInfo,
    tableStatus,
  ]);

  const handlePageChange = (page) => {
    fetchRadiology(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchRadiology(1, newLimit, searchValue);
  };

  useEffect(() => {
    showTostifyMessageAndReset(
      updateRadiologyMaterSuccessMessage,
      showToastifySuccess,
      retsetUpdateRadiologyMaterMessage,
    );
    showTostifyMessageAndReset(
      updateRadiologyMaterErrorMessage,
      showToastifyError,
      retsetUpdateRadiologyMaterMessage,
    );
    showTostifyMessageAndReset(
      deleteRadiologyMaterSuccessMessage,
      showToastifySuccess,
      resetDeleteRadiologyMaterMessage,
    );
    showTostifyMessageAndReset(
      deleteRadiologyMaterErrorMessage,
      showToastifyError,
      resetDeleteRadiologyMaterMessage,
    );
  }, [
    dispatch,
    showTostifyMessageAndReset,
    updateRadiologyMaterSuccessMessage,
    updateRadiologyMaterErrorMessage,
    deleteRadiologyMaterSuccessMessage,
    deleteRadiologyMaterErrorMessage,
  ]);

  const tableHead = [
    { title: "Service Name", key: "serviceName" },
    { title: "Service Details", key: "name" },
    { title: "Patient Price", key: "pt_price" },
    { title: "Clint Price", key: "client_Price" },
    { title: "Status", key: "status" },
  ];

  const title = [
    { title: "Service Name", key: "serviceName" },
    { title: "Service Details", key: "name" },
    { title: "Patient Price", key: "pt_price" },
    { title: "Clint Price", key: "client_Price" },
    { title: "Status", key: "status" },
  ];

  const handleAddModal = () => {
    setRadiologyMasterFormData(initialState);
    setModalVisible(true);
  };
  const handleShowGlobalViewModal = (data) => {
    setRadiologyMasterFormData(data);
    setShowGlobalViewModal(true);
  };
  const handleSetRadiologyMasterFormData = (selectedOptions, names) => {
    if (names === "serviceDetails") {
      const filteredOptions = selectedOptions.filter((option) => option);
      const selectedValues = filteredOptions.map((option) => option.value);
      const selectedLabels = filteredOptions.map((option) => option.label);
      setRadiologyMasterFormData({
        ...radiologyMasterFormData,
        serviceDetailsId: selectedValues,
        serviceDetailsName: selectedLabels.join(", "),
      });
    } else if (names === "service") {
      setRadiologyMasterFormData({
        ...radiologyMasterFormData,
        serviceId: selectedOptions.value,
        serviceName: selectedOptions.label,
      });
    } else {
      setRadiologyMasterFormData({
        ...radiologyMasterFormData,
        [selectedOptions.target.name]: selectedOptions.target.value,
      });
    }
  };

  const handleUpdate = (item) => {
    setModalVisible(true);
    setRadiologyMasterFormData({
      id: item?.id,
      serviceId: item?.serviceId,
      serviceName: item?.serviceName,
      name: item?.name,
      weight: item?.weight,
      pt_price: item?.pt_price,
      client_Price: item?.client_Price,
      tax: item?.tax,
      status: item?.status,
    });
  };

  const handleAddOrUpdateRadiologyMaster = async (e) => {
    e.preventDefault();
    const { onlyNumber } = inputError;
    if (onlyNumber) return;
    try {
      await dispatch(
        updateClinicRadiologyServicesDetailsMaster({
          ...radiologyMasterFormData,
          clinicId,
          token,
        }),
      );
      setRadiologyMasterFormData(initialState);
      setModalVisible(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = (data) => {
    setRadiologyMasterFormData({
      id: data?.id,
      name: data?.name,
    });
    setDeleteModal(true);
  };

  const handleConfirmDelete = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        deleteRadiologyServiceDetails({
          id: radiologyMasterFormData?.id,
          token,
        }),
      );
      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };
  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchRadiology(1, pageLimit, value);
    },
    [fetchRadiology, pageLimit],
  );

  const handleUpdateStatus = async (status, item) => {
    try {
      const updateData = {
        id: item?.id,
        status: status,
        clinicId,
        token,
      };
      await dispatch(updateClinicRadiologyServicesDetailsMaster(updateData));
      if (clinicId) {
        fetchRadiology(currentPage, pageLimit, searchValue);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <Table
        tableHead={tableHead && tableHead}
        tableBody={
          radiologyServicesDetails &&
          radiologyServicesDetails?.map((item) => ({
            id: item?._id,
            serviceId: item?.serviceId?._id,
            serviceName: item?.serviceId?.name,
            name: item?.name,
            weight: item?.weight,
            pt_price: item?.pt_price,
            client_Price: item?.client_Price,
            tax: item?.tax,
            status: item?.status,
          }))
        }
        addModal={handleAddModal}
        handleSearch={handleSearch}
        handleEdit={handleUpdate}
        handleDelete={handleDelete}
        errorMessage={searchMessage}
        searchValue={searchValue}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />

      {/* Add and Update treatment Modal */}
      <AddUpdateClinicRadiologyMaster
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        radiologyMasterFormData={radiologyMasterFormData}
        handleAddOrUpdateRadiologyMaster={handleAddOrUpdateRadiologyMaster}
        handleSetRadiologyMasterFormData={handleSetRadiologyMasterFormData}
        setInputError={setInputError}
      />

      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={title && title}
        content={{
          serviceName: radiologyMasterFormData?.serviceName,
          name: radiologyMasterFormData?.name,
          pt_price: radiologyMasterFormData?.pt_price,
          client_Price: radiologyMasterFormData?.client_Price,
          status: radiologyMasterFormData?.status,
        }}
      />
      {/* Add and Update Treatment Modal end */}

      {/* delete Modal */}
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete the Service{" "}
            <strong className="text-dark">
              {radiologyMasterFormData?.name}
            </strong>
            ?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ClinicRadiologyServicesMaster;
